import _defineProperty from "/var/www/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ApolloLink } from '@apollo/client';
export var localeMiddleware = function localeMiddleware(getLocale) {
  return new ApolloLink(function (operation, forward) {
    operation.setContext(function (_ref) {
      var _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? {} : _ref$headers;
      return {
        headers: _objectSpread(_objectSpread({}, headers), {}, {
          'X-localization': getLocale()
        })
      };
    });
    return forward(operation);
  });
};